const syncVideoPatternHeight = (media, video) => {
  if (!media || !video || !video.videoWidth || !video.videoHeight) {
    return;
  }

  const mediaWidth = media.getBoundingClientRect().width;

  if (!mediaWidth) {
    return;
  }

  const mediaHeight = mediaWidth * (video.videoHeight / video.videoWidth);
  media.style.height = `${mediaHeight}px`;
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-video-toggle]');

  if (!toggle) {
    return;
  }

  const media = toggle.closest('.video-z-pattern__media');
  const video = media && media.querySelector('video');

  if (!video) {
    return;
  }

  if (video.paused) {
    video.play();
    toggle.classList.remove('is-paused');
    toggle.setAttribute('aria-label', 'Pause video');
    toggle.setAttribute('aria-pressed', 'true');
    return;
  }

  video.pause();
  toggle.classList.add('is-paused');
  toggle.setAttribute('aria-label', 'Play video');
  toggle.setAttribute('aria-pressed', 'false');
});

document.addEventListener('DOMContentLoaded', () => {
  const watchedVideos = [];

  document.querySelectorAll('.video-z-pattern__media').forEach((media) => {
    const video = media.querySelector('video');
    const toggle = media.querySelector('[data-video-toggle]');

    if (!video || !toggle) {
      return;
    }

    const syncHeight = () => syncVideoPatternHeight(media, video);
    const syncState = () => {
      const paused = video.paused;

      toggle.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');
    };

    syncHeight();
    syncState();
    video.addEventListener('loadedmetadata', syncHeight);
    video.addEventListener('loadeddata', syncHeight);
    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    watchedVideos.push({ media, video, syncHeight });
  });

  if (!watchedVideos.length) {
    return;
  }

  window.addEventListener('resize', () => {
    watchedVideos.forEach(({ syncHeight }) => syncHeight());
  });
});